<template>
  <div class="tournament-content-tab tab-drawing" v-bind:class="{'tournament-content-active-tab':activeTab == 4}">
    <!--        <div class="row" style="padding-left: 500px;">-->
   <div class="categories-container categories-draw-container">
     <div class="row">
       <div class="col-md-12 fixed-categories" style="">
         <section class="adm-panel draw-picker" :class="{collapsed: !pickerExpanded}" ref="drawPicker">
           <!-- Поточна категорія + згортання списку -->
           <div class="draw-current" v-if="selectedDrawCategory">
             <div class="draw-current-info">
               <span class="adm-label">Обрана категорія</span>
               <div class="draw-current-name">
                 {{ selectedDrawCategory.fullname || selectedDrawCategory.name }}
                 <span class="adm-chip"><tkd-icon name="team"/> {{ selectedDrawCategory.count_sportsmans || selectedDrawCategory.count || 0 }}</span>
                 <span class="adm-chip">{{ selectedDrawCategory.show_type == 1 ? 'сітка' : 'список' }}</span>
                 <span class="adm-chip warn" v-if="getCategoryDrawingStatus(selectedDrawCategory) === 'draft'">чернетка</span>
                 <span class="adm-chip ok" v-if="getCategoryDrawingStatus(selectedDrawCategory) === 'completed'">жеребкування є</span>
               </div>
             </div>
             <button type="button" class="adm-btn adm-btn-sm" @click="pickerExpanded = !pickerExpanded" :aria-expanded="pickerExpanded ? 'true' : 'false'">
               <tkd-icon :name="pickerExpanded ? 'chevron-up' : 'chevron-down'"/> {{ pickerExpanded ? 'Згорнути список' : 'Показати всі категорії' }}
             </button>
           </div>

           <tournament-category-list
             :categories="allProtocols"
             title="Всі категорії"
             list-id="category_list_drawing"
             :hide-empty-default="true"
             :selected-id="selectedDrawCategory && selectedDrawCategory.id"
             wrapper-columns="repeat(2, minmax(0, 1fr))"
             list-columns="repeat(2, minmax(0, 1fr))"
             @item-click="selectDrawCategory">
             <template #navigation-actions>
               <button type="button" class="adm-btn adm-btn-sm adm-btn-danger" @click="toogleAutoSortableShemeAll()" title="Перезапише всі попередні жеребкування">
                 <tkd-icon name="warning"/> Автоматичне жеребкування всіх категорій
               </button>
             </template>
             <template #item-main-prefix="{ item }">
               <tkd-icon name="list" v-if="selectedDrawCategory && selectedDrawCategory.show_type == 2"/>
               <span class="draft-status-badge" v-if="getCategoryDrawingStatus(item) === 'draft'" title="Чернетка жеребкування">
                 <tkd-icon name="edit" style="color: #f79009;"/>
               </span>
               <span class="draft-status-badge" v-if="getCategoryDrawingStatus(item) === 'completed'" title="Жеребкування завершено">
                 <tkd-icon name="check" style="color: #17b26a;"/>
               </span>
             </template>
           </tournament-category-list>
         </section>
       </div>

       <!--      Сітка + закріплений список спортсменів, яких ще немає в сітці -->
       <div class="col-md-12" v-if="selectedDrawCategory && selectedDrawCategory.show_type == 1">
         <div class="draw-layout">
           <aside class="pending-panel">
             <div class="adm-panel pending-card" :class="{ 'is-sortable': sortableOn }">
               <div class="pending-head">
                 <h3 class="pending-title">Не в сітці</h3>
                 <span class="adm-chip" :class="pendingCount > 0 ? 'warn' : 'ok'">{{ pendingCount }}</span>
               </div>

               <p class="pending-hint" v-if="pendingCount > 0 && sortableOn">
                 <tkd-icon name="hand"/> Перетягніть спортсмена на місце в сітці. Зміни зберігаються автоматично.
               </p>
               <p class="pending-hint pending-hint-off" v-else-if="pendingCount > 0">
                 Щоб розставити спортсменів, увімкніть «<tkd-icon name="hand"/> Ручне жеребкування» над сіткою.
               </p>

               <div class="pending-search" v-if="filteredBrackedInSPortsmans.length > 6">
                 <input type="search" class="adm-input" v-model="pendingSearch" placeholder="Пошук: ПІБ, клуб, область" aria-label="Пошук спортсмена">
               </div>

               <!-- id, класи sp-item/sortable-drag-item і data-sp потрібні Swappable у Bracket*.vue — не змінювати -->
               <!-- :key з pendingGen — після зміни даних Vue створює контейнер заново (див. resetPendingDom) -->
               <div id="pendingdrawingblock" class="pending-drawing-block" ref="pendingBlock" :key="'pending-block-' + pendingGen">
                 <div :data-sp="item.id" class="sp-item  sortable-drag-item"
                      v-for="(item, index) in filteredBrackedInSPortsmans"
                      :key="selectedDrawCategory.id+'_pending_drawing_'+index" v-if="item.in_bracket < 1">
                   <div class="group-team group-team-top text-top-line "><span class="tehnical-number"></span>{{ item.name }}
                   </div>
                   <div class="group-team group-team-top text-bottom-line" v-if="item.organization || item.oblast">{{ [item.organization, item.oblast].filter(Boolean).join(' / ') }}</div>
                   <div class="group-team group-team-top line-center"></div>
                 </div>
               </div>

               <div class="pending-done" v-if="pendingCount === 0"><tkd-icon name="check"/> Усі спортсмени в сітці</div>
               <div class="pending-done pending-nothing" v-else-if="pendingSearch && pendingVisible === 0">Нікого не знайдено</div>
             </div>
           </aside>

           <div class="draw-bracket">
             <brackets-constructor :selectedDrawCategory.sync="selectedDrawCategory"
                                   @sortable-change="sortableOn = $event"
                                   @bracket-saved="recountPending"></brackets-constructor>
           </div>
         </div>
       </div>


     </div>
   </div>

    <div class="row categories-poomsae-list-container" v-if="selectedDrawCategory && selectedDrawCategory.show_type != 1">
<!--      Сетки-->
<!--      <div class="col-md-12" v-if="selectedDrawCategory.show_type == 1">
        <brackets-constructor :selectedDrawCategory.sync="selectedDrawCategory"></brackets-constructor>
      </div>-->
      <!--      списки-->
      <div class="col-md-12 poomsae-container" >

        <result-constructor :selectedDrawCategory.sync="selectedDrawCategory"></result-constructor>
      </div>


    </div>
  </div>
</template>

<script>
import UserBracketsContructor from 'src/pages/tools/UserBracketsContructor.vue';
import ResultContructor from 'src/pages/tools/ResultContructor.vue';
import ListContructor from 'src/pages/tools/ListContructor.vue';
import ListContructorNew from 'src/pages/tools/ListContructorNew.vue';
import TournamentCategoryList from 'src/components/TournamentCategoryList.vue';
import 'src/assets/css/tkd-theme.css';
import 'src/assets/css/tkd-admin.css';

export default {
  name: "tab-drawing",
  props: ['category'],
  components: {
    'list-constructor-new': ListContructorNew,
    'list-constructor': ListContructor,
    'brackets-constructor': UserBracketsContructor,
    'result-constructor': ResultContructor,
    'tournament-category-list': TournamentCategoryList,
  },
  data() {
    return {
      selectedCategory: 0,
      showBracketCategories: false,
      regions: [],
      file: '',
      // список категорій згорнутий до кількох рядків, щоб сітка була ближче
      pickerExpanded: false,
      // стан панелі "Не в сітці"
      sortableOn: false,
      pendingSearch: '',
      // після перетягування DOM змінює Swappable, тому рахуємо по DOM (null — ще не рахували)
      pendingCountDom: null,
      pendingVisible: 0,
      pendingGen: 0,
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters['settings/activeTournamentTab'];
    },
    tournamentOne() {
      return this.$store.getters['tournament/tournamentOne'];
    },
    allProtocols() {
      if (this.tournamentOne.data && this.tournamentOne.data.item && this.tournamentOne.data.item.protocols) {
        return this.tournamentOne.data.item.protocols;
      }
      return [];
    },

    filteredBrackedInSPortsmans(){
      var list = [];

      // Check if selectedDrawCategory exists
      if (!this.selectedDrawCategory || this.selectedDrawCategory.sportsmans == undefined) return list;


      let length =  Object.keys(this.selectedDrawCategory.sportsmans).length ;

      console.log("length selectedDrawCategory.sportsmans ", length);


      // this.selectedDrawCategory.sportsmans

      for (const sportsmansKey in this.selectedDrawCategory.sportsmans) {
        const in_bracket  = this.selectedDrawCategory.sportsmans[sportsmansKey].in_bracket;
        if (in_bracket < 1){
          list.push(this.selectedDrawCategory.sportsmans[sportsmansKey]);

            }

      }


      // for (let i = 0; i < length; i++) {
      //
      //   // const in_bracket  = this.selectedDrawCategory.sportsmans[i].in_bracket;
      //   // if (in_bracket < 1){
      //     list.push(this.selectedDrawCategory.sportsmans[i]);
      //
      //   // }
      //
      //   // if (this.tournamentOne.data.item.protocols[i].id === this.selectedCategory) {
      //   //
      //   // }
      // }

      // age_category.


      console.log('list', list);
      return list;
    },
    pendingCount() {
      return this.pendingCountDom != null ? this.pendingCountDom : this.filteredBrackedInSPortsmans.length;
    },
    selectedDrawCategory() {
      // Check if protocols exists
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.protocols || this.tournamentOne.data.item.protocols.length === 0) {
        return null;
      }

      if (this.selectedCategory != undefined && this.selectedCategory > 0) {
        console.log('this.category ', this.selectedCategory);

        let length = this.tournamentOne.data.item.protocols.length;
        for (let i = 0; i < length; i++) {
          if (Number(this.tournamentOne.data.item.protocols[i].id) === Number(this.selectedCategory)) {
            return this.tournamentOne.data.item.protocols[i];
          }
        }
      }
      return this.tournamentOne.data.item.protocols[0];
    },
  },

  mounted() {
    this.selectedCategory = this.category != undefined ? Number(this.category) : 0;
    // Load drawing drafts from localStorage on mount
    this.$store.dispatch('tournament/loadDrawingDrafts');
  },

  watch: {
    '$route.params.category'(newCategory) {
      this.selectedCategory = newCategory != undefined ? Number(newCategory) : 0;
    },
    // у згорнутому списку прокручуємо до обраної категорії (лише сам список, не сторінку)
    selectedDrawCategory() {
      this.$nextTick(() => this.scrollPickerToSelected());
      // нові дані категорії — список знову з сервера
      this.pendingCountDom = null;
      this.pendingSearch = '';
      this.resetPendingDom();
    },
    pendingSearch() {
      this.filterPending();
    },
    activeTab() {
      this.$nextTick(() => this.scrollPickerToSelected());
    },
  },

  updated() {
    // this.openCategoryFromUrl();
    // console.log('selectedDrawCategory.show_type ', this.selectedDrawCategory.show_type);
  },


  methods: {
    // Swappable переносить елементи між сіткою і списком поза Vue, тож оновлювати список по елементах
    // не можна (нові вставляються не туди). Після зміни даних замінюємо весь контейнер разом із залишками із сітки.
    // Ручне жеребкування при цьому вимикається (initCategory у сітці), а при увімкненні Swappable бере новий #pendingdrawingblock.
    resetPendingDom() {
      this.pendingGen++;
    },
    pendingItems() {
      const block = this.$refs.pendingBlock;
      if (!block) return [];
      return [...block.querySelectorAll('.sp-item')].filter(el =>
        !el.classList.contains('draggable--original') && !el.classList.contains('draggable-mirror'));
    },
    // рахуємо реальних спортсменів у списку (порожні слоти з сітки теж можуть сюди потрапити)
    recountPending() {
      this.$nextTick(() => {
        this.pendingCountDom = this.pendingItems().filter(el => {
          const id = el.getAttribute('data-sp');
          return id && id !== '0' && !el.classList.contains('empty');
        }).length;
        this.filterPending();
      });
    },
    // фільтр через DOM, а не v-for: Swappable переносить елементи між списком і сіткою
    filterPending() {
      const query = this.pendingSearch.trim().toLowerCase();
      let visible = 0;
      this.pendingItems().forEach(el => {
        const match = !query || el.textContent.toLowerCase().includes(query);
        el.style.display = match ? '' : 'none';
        if (match && !el.classList.contains('empty')) visible++;
      });
      this.pendingVisible = visible;
    },
    scrollPickerToSelected() {
      const picker = this.$refs.drawPicker;
      if (!picker || this.pickerExpanded) return;
      const list = picker.querySelector('.category_list_drawing_wrapper');
      const selected = list && list.querySelector('.category-item.bg-info');
      if (!selected) return;
      const top = selected.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
      list.scrollTop = Math.max(0, top - 40);
    },

    getCategoryDrawingStatus(category) {
      // Check if there's a draft for this category
      const hasDraft = this.$store.getters['tournament/hasDrawingDraft'](category.id);
      if (hasDraft) {
        return 'draft';
      }

      // Check if drawing is completed (has drawdata with sportsmen in bracket)
      if (category.drawdata && category.drawdata.length > 0) {
        const hasSportsmen = category.drawdata.some(item => item.sp_id > 0);
        if (hasSportsmen) {
          return 'completed';
        }
      }

      return 'empty';
    },


    selectDrawCategory(category) {
      if (!category || !category.id || !this.tournamentOne.data || !this.tournamentOne.data.item) {
        return;
      }

      const currentScrollY = window.scrollY;
      this.selectedCategory = category.id;
      this.$store.dispatch('settings/setActiveCategoryId', category.id);
      this.$router.replace({
        path: `/user/tournaments/overview/${this.tournamentOne.data.item.id}/bracket/${category.id}`,
        query: {
          ...this.$route.query,
          tab: 'drawing',
        },
      }).then(() => {
        this.$nextTick(() => {
          window.scrollTo(0, currentScrollY);
        });
      }).catch(() => {
        window.scrollTo(0, currentScrollY);
      });
      // this.$des''troy();
      // this.$destroy(UserBracketsContructor);
      // var vm = new tmp().$mount('#mount-point');
      // vm.$destroy();

      // console.log('category index', category);

      // this.selectedDrawCategory = this.tournamentOne.data.item.protocols[category];
      // let selectedDrawCategory = this.tournamentOne.data.item.protocols[category];

      // this.$router.replace({ path: `/user/tournaments/overview/${this.tournamentOne.data.item.id}/bracket/${selectedDrawCategory.id}` }) // -> /user/123
      // window.location = `/user/tournaments/overview/${this.tournamentOne.data.item.id}/bracket/${selectedDrawCategory.id}`;
      // http://localhost:8080/user/tournaments/overview/4/bracket/195
      // this.selectedDrawCategory = category;
    },
    // Автоматическа жеребьевка всех категорий
    toogleAutoSortableShemeAll() {
      console.log('toogleAutoSortableShemeAll');

      let params = {
        tournament_id: this.tournamentOne.data.item.id,
        time: new Date().getTime(),
      };

      if (window.confirm("Прожеребкувати всі категорії автоматично? Попередні жеребкування будуть стерті.")) {
        this.$store.dispatch('tournament/autoSortableBracketAll', params).then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: params.tournament_id}))
            .then(() => this.updateBracket());
      }

      // this.$store.dispatch('tournament/autoSortableBracket', params).then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: params.tournament_id}))
      //   .then(() => window.location.reload());


      // if (this.sortableSheme === true) {
      //   this.disableToogleSortableSheme();
      // } else if (this.sortableSheme !== true) {
      //   this.enableToogleSortableSheme();
      // }

    },

    updateBracket() {
      alert('Дані оновлено');
      window.location.reload();
    }

  }

}
</script>

<style lang="scss" scoped>

.tab-drawing {
  /* перекриває .tournament-content-tab { background:#fff } з _custom.scss */
  background: transparent;
  font-family: var(--tkd-font);
}

.draw-current {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px dashed var(--tkd-border);
}

.draw-current-name {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 18px;
  font-weight: 800;
  color: var(--tkd-text);
}

/* Сітка + список "Не в сітці" */
.draw-layout {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

.draw-bracket { min-width: 0; }

/* список закріплений під табами турніру (таби: top 8px + ~54px) */
.pending-panel {
  position: sticky;
  top: 72px;
  z-index: 5;
}

.pending-card {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 88px);
  margin-bottom: 0;
  padding: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pending-card.is-sortable { border-color: var(--adm-ok-strong); box-shadow: 0 0 0 3px var(--adm-ok-bg), var(--tkd-shadow); }

.pending-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.pending-title { margin: 0; font-size: 16px; font-weight: 800; color: var(--tkd-text); }

.pending-hint {
  margin: 10px 0 0;
  padding: 8px 10px;
  border-radius: 10px;
  background: var(--adm-ok-bg);
  font-size: 13px;
  line-height: 1.4;
  color: var(--adm-ok);
}

.pending-hint-off {
  background: var(--tkd-bg);
  color: var(--tkd-muted);
}

.pending-search { margin-top: 10px; }
.pending-search .adm-input { height: 38px; }

.pending-drawing-block {
  flex: 1;
  min-height: 0;
  margin: 10px -4px 0 0;
  padding-right: 4px;
  overflow-y: auto;
  scrollbar-width: thin;
}

/* картки спортсменів у списку; ::v-deep — бо сюди потрапляють і елементи з сітки */
.pending-drawing-block ::v-deep .sp-item {
  position: relative;
  margin: 0 0 8px;
  padding: 8px 10px 8px 26px;
  border: 1.5px solid var(--tkd-border);
  border-radius: var(--tkd-radius);
  background: var(--tkd-surface);
  font-family: var(--tkd-font);
  transition: border-color 0.15s, box-shadow 0.15s;

  .text-top-line { font-size: 14px; font-weight: 700; line-height: 1.3; color: var(--tkd-text); overflow-wrap: anywhere; }
  .text-bottom-line { margin-top: 2px; font-size: 12px; font-style: normal; color: var(--tkd-muted); overflow-wrap: anywhere; }
  .line-center, .tehnical-number, .btn { display: none; }

  /* "ручка" для перетягування */
  &::before {
    content: '⋮⋮';
    position: absolute;
    left: 9px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    letter-spacing: -2px;
    color: var(--tkd-border);
  }
}

/* порожні слоти сітки, що потрапили у список, — без спортсмена нічого не показуємо */
.pending-drawing-block ::v-deep .sp-item:not([data-sp]),
.pending-drawing-block ::v-deep .sp-item[data-sp=""],
.pending-drawing-block ::v-deep .sp-item[data-sp="0"] {
  display: none !important;
}

.pending-card.is-sortable .pending-drawing-block ::v-deep .sp-item {
  cursor: grab;

  &:hover { border-color: var(--adm-ok-strong); box-shadow: 0 4px 12px rgba(10, 31, 68, 0.08); }
  &::before { color: var(--adm-ok-strong); }
}

.pending-done {
  padding: 16px 8px;
  border: 2px dashed var(--adm-ok-border);
  border-radius: var(--tkd-radius);
  background: var(--adm-ok-bg);
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: var(--adm-ok);
}

.pending-nothing { border-color: var(--tkd-border); background: var(--tkd-bg); color: var(--tkd-muted); }

@media (max-width: 991px) {
  .draw-layout { grid-template-columns: 1fr; }
  .pending-panel { position: static; }
  .pending-card { max-height: 50vh; }
}

/* згорнутий список: фіксована висота з прокруткою */
.draw-picker.collapsed ::v-deep .category_list_drawing_wrapper {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
}

.categories-container{

  .draft-status-badge {
    display: inline-block;
    margin-right: 5px;
    vertical-align: middle;

    i, .tkd-icon {
      font-size: 14px;
      font-weight: bold;
    }
  }

  .bg-info {
    background-color: #007bff !important;
    color: #fff;
  }

  .category-filters{
    .nav.nav-tabs{
      border: none;
    }
    .nav-item{
      border-radius: 4px 4px 4px 4px;
      background-color: #6c757d;
      border: 1px solid #fff;
    }

    .nav-item.active, .nav-item:focus, .nav-item:hover{
      //background-color: #007bff;


      > a, a:hover{
        background-color: #007bff;
        color: #fff;
      }
    }
  }

  .navigation-panel{
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .category_list_drawing_wrapper{
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 20px;

    .category_list_drawing{
      display: grid;
      grid-template-columns: auto  auto;
      grid-gap: 10px;

      .category-item{
        border: 1px solid #d6dde8;
        background: #f6f8fb;
        border-radius: 8px;
        padding: 0;
        overflow: hidden;
        transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
      }

      .category-item:hover {
        transform: translateY(-1px);
      }

      .category-item-inner{
        display: grid;
        grid-template-columns: 58px 1fr;
        min-height: 100%;
      }

      .category-item-side{
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid rgba(255,255,255,0.45);
        font-weight: 700;
      }

      .category-item-main{
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 10px;
        min-width: 0;
      }

      .category-item-name{
        display: inline-block;
        min-width: 0;
      }

      .category-item.man-category{
        border-color: #bfd4f6;
        background: #edf4ff;

        .category-item-side{
          background: #4d8ff7;
          color: #fff;
        }
      }

      .category-item.woman-category{
        border-color: #f2bfdc;
        background: #fff0f7;

        .category-item-side{
          background: #e056a0;
          color: #fff;
        }
      }

      .category-item.other-category{
        border-color: #d6c8a4;
        background: #fff8e8;

        .category-item-side{
          background: #b58a24;
          color: #fff;
        }
      }

      .category-item.bg-info{
        border-color: #0a58ca !important;
        background: #007bff !important;

        .category-item-side{
          background: #083b8a !important;
          color: #fff;
        }

        .category-item-main{
          color: #fff;
        }
      }

      .category-count-sportsmans{
        width: 100%;
        padding: 10px 4px;
        text-align: center;
        font-size: 13px;
        line-height: 1;
      }
    }
  }
}

</style>
